import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(
        localStorage.getItem("foodb-user") ? JSON.parse(localStorage.getItem("foodb-user")) : null
    );

    const login = (jwt, data) => {
        localStorage.setItem("foodb-user", JSON.stringify({ jwt, data }));
        setUser({ jwt, data });
    };

    const logout = () => {
        localStorage.removeItem("foodb-user");
        setUser(null);
    };

    return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

const useAuth = () => {
    return useContext(AuthContext);
};

export default useAuth;
